import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import newsController from '../../api/newsController';
let publicUrl = process.env.PUBLIC_URL + '/'
let imagealt = 'image'
function TobNews() {

	const [news, setNews] = React.useState([]);
	React.useEffect(() => {
		let news = newsController.getNews();
		setNews(news);
	}, [])
	const renderNews = () => {
		let news2 = news.slice(8, 12);
		return news2.map((item, index) => {
			return (				<div className="col-lg-3 col-sm-6">
				<div className="single-post-wrap style-overlay">
					<div className="thumb">
						<img style={{width: "500px", height: "300px"}} src={item.photo_url} alt="img" />
					</div>
					<div className="details">
						<div className="post-meta-single">
							<ul>
								<li><i className="fa fa-clock-o" />{new Date(item.published_datetime_utc).toLocaleDateString()}</li>
								<li><i className="fa fa-user" />{item.authors[0]}</li>
							</ul>
						</div>
						<h6 className="title"><a target='_blank' href={item.link}>{item.title} </a></h6>
					</div>
				</div>
			</div>)
		})
	}

	return (<div className="top-area pd-top-75 pd-bottom-50 go-top">
		<div className="container">

			<div className="row">
				{renderNews()}
			</div>
		</div>
	</div>)
}

export default TobNews